export default __webpack_public_path__ + "static/media/Icon awesome-calendar-day.6bf36cdd.svg";